import { useTranslation } from 'react-i18next';

import TitleQuotation from './../components/title-quotation';
import DownloadQuotation from './../components/download-quotation';
import AcceptQuotationForm from './../components/Forms/accept-quotation-form';
import Hr from '../../../components/Style/hr';
import GroupDownloadQuotations from '../components/group-download-quotations';

export default function FirstStepAcceptQuotation({ quotation, group, quotations = [], returnedData }) {
    const { t } = useTranslation();

    const isGroup = !!group && Array.isArray(quotations) && quotations.length > 0;

    const handleReturnedData = (data) => {
        returnedData(data);
    };

    return (
        <>
            <TitleQuotation title={t('pageQuotation.step1.welcomeMessage')} description={t('pageQuotation.step1.description')} step="1" />
            <Hr />
            {isGroup ? (
                <GroupDownloadQuotations group={group} quotations={quotations} />
            ) : (
                <DownloadQuotation quotation={quotation} />
            )}
            <Hr />
            <AcceptQuotationForm quotation={quotation || quotations[0]} group={group} quotations={quotations} returnedData={handleReturnedData} />
        </>
    );
}